import {
  readCase,
  editCase,
  createCase,
  deleteCase,
} from "~/shared/caseAbilities"

export const useCasePermissions = async () => {
  const canReadCase = await allows(readCase)
  const canEditCase = await allows(editCase)
  const canCreateCase = await allows(createCase)
  const canDeleteCase = await allows(deleteCase)

  return { canReadCase, canEditCase, canCreateCase, canDeleteCase }
}
